import _ from 'lodash';
import React from 'react';
import autoBind from 'react-autobind';
import Formatter from '../utils/Formatter.js';
import ContentService from '../services/ContentService';
import ErrorHandlerStore from '../stores/ErrorHandlerStore';
import OmnitureTracking from '../utils/OmnitureTracking';

const getState = () => {
    return _.merge({
        content: ContentService.getContent().errorPage
    }, 
    ErrorHandlerStore.getStore());
}

class Error extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getState();
    }

    componentDidMount() {
        OmnitureTracking.getTrackingEnabled();
    }
    
    render() {
        const reference = this.state.correlationId ? <p className="reference-number">{Formatter.formatString(this.state.content.reference, { correlationId: this.state.correlationId })}</p> : null;
        return (
            <div className="error">
                    <nav className="navbar-sub-title navbar navbar-sub">
                        <div className="container">
                            <div className="pull-left">
                                <h2>{this.state.content.pageTitle}</h2>
                            </div>
                        </div>
                    </nav>

                    <div className="container content">
                        <h4 className="text-danger">{this.state.content.header}</h4>
                        {reference}
                        <div dangerouslySetInnerHTML={{__html: this.state.content.support}}></div>
                    </div>
            </div>
        );
    }
}

export default Error


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Error.jsx